import React from 'react';
import { X, Check } from 'lucide-react';

const Comparison = () => {
  return (
    <section id="comparison" className="py-32 bg-black">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-20">
          <span className="text-teal-400 text-sm uppercase tracking-widest font-semibold mb-4 block">
            Comparativa
          </span>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
            La Diferencia Es Clara
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            No todos los MBAs son iguales. Descubre por qué miles de emprendedores eligen Urpe.
          </p>
        </div>

        {/* Comparison Grid */}
        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {/* Traditional MBAs */}
          <div className="bg-gradient-to-br from-white/5 to-transparent border border-white/10 rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-gray-400 mb-8 text-center">MBAs Tradicionales</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <X className="text-red-400 flex-shrink-0 mt-1" size={20} />
                <span className="text-gray-400">US$100,000 promedio de inversión</span>
              </li>
              <li className="flex items-start space-x-3">
                <X className="text-red-400 flex-shrink-0 mt-1" size={20} />
                <span className="text-gray-400">Teoría poco aplicable al día a día</span>
              </li>
              <li className="flex items-start space-x-3">
                <X className="text-red-400 flex-shrink-0 mt-1" size={20} />
                <span className="text-gray-400">Profesores sin operación real</span>
              </li>
              <li className="flex items-start space-x-3">
                <X className="text-red-400 flex-shrink-0 mt-1" size={20} />
                <span className="text-gray-400">Burocracia y tiempos largos</span>
              </li>
              <li className="flex items-start space-x-3">
                <X className="text-red-400 flex-shrink-0 mt-1" size={20} />
                <span className="text-gray-400">Titulación sin impacto inmediato</span>
              </li>
              <li className="flex items-start space-x-3">
                <X className="text-red-400 flex-shrink-0 mt-1" size={20} />
                <span className="text-gray-400">Contenido desactualizado</span>
              </li>
            </ul>
          </div>

          {/* Urpe MBA */}
          <div className="relative bg-gradient-to-br from-teal-950/30 to-gray-950/30 border-2 border-teal-500/50 rounded-2xl p-8 shadow-2xl shadow-teal-500/20">
            {/* Highlight badge */}
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
              <span className="px-4 py-1 bg-gradient-to-r from-teal-500 to-teal-600 text-black text-xs font-bold rounded-full">
                RECOMENDADO
              </span>
            </div>

            <h3 className="text-2xl font-bold text-white mb-8 text-center">Urpe Liberty MBA</h3>
            <ul className="space-y-4 mb-8">
              <li className="flex items-start space-x-3">
                <Check className="text-teal-400 flex-shrink-0 mt-1" size={20} />
                <span className="text-white font-medium">Beca 50%–100% disponible</span>
              </li>
              <li className="flex items-start space-x-3">
                <Check className="text-teal-400 flex-shrink-0 mt-1" size={20} />
                <span className="text-white font-medium">100% práctico y accionable</span>
              </li>
              <li className="flex items-start space-x-3">
                <Check className="text-teal-400 flex-shrink-0 mt-1" size={20} />
                <span className="text-white font-medium">Mentores que operan empresas reales</span>
              </li>
              <li className="flex items-start space-x-3">
                <Check className="text-teal-400 flex-shrink-0 mt-1" size={20} />
                <span className="text-white font-medium">Aplicación inmediata al negocio</span>
              </li>
              <li className="flex items-start space-x-3">
                <Check className="text-teal-400 flex-shrink-0 mt-1" size={20} />
                <span className="text-white font-medium">Educación basada en resultados</span>
              </li>
              <li className="flex items-start space-x-3">
                <Check className="text-teal-400 flex-shrink-0 mt-1" size={20} />
                <span className="text-white font-medium">Contenido actualizado constantemente</span>
              </li>
            </ul>

            <a
              href="#admissions"
              className="block text-center px-8 py-4 bg-gradient-to-r from-teal-500 to-teal-600 text-black font-semibold rounded-full hover:from-teal-400 hover:to-teal-500 transition-all duration-300 shadow-2xl shadow-teal-500/30 hover:shadow-teal-500/50"
            >
              Aplicar a la Beca Libertad
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Comparison;
